import styled from 'styled-components';
import { Text14Light } from '../../utils/Text/Text.styles';
import { Button } from '../../utils/Button/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-bottom: 2.8rem;
`;

export const Subtitle = styled(Text14Light)`
  opacity: 0.67;
`;

export const VoiceNameContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 4.6rem;
  border-radius: 12px;
  border: 1px solid #d2d6db;
  padding: 0.8rem;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  svg {
    cursor: pointer;
  }
`;

export const VoiceUploadContainer = styled.div`
  display: flex;
  gap: 1.4rem;

  @media only screen and (max-width: 500px) {
    flex-direction: column;
  }
`;

export const ContinueButton = styled(Button)`
  margin-top: 3rem;
  width: 24rem;
  margin-inline: auto;

  @media only screen and (max-width: 500px) {
    margin-top: auto;
    width: 100%;
    margin-bottom: 3rem;
  }
`;

export const BackContainer = styled.div`
  position: absolute;
  top: 2.4rem;
`;

export const StyledButton = styled(Button)`
  width: 16rem;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const VoiceNameContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const TestVoiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-top: 2.4rem;
`;
export const Row = styled.div`
  display: flex;
  gap: 0.8rem;

  @media only screen and (max-width: 500px) {
    flex-direction: column;
    gap: 0;
    margin-bottom: 2rem;
  }
`;

export const TestButton = styled(Button)`
  min-width: 12rem;
  width: 12rem;
  margin-top: 2.4rem;

  @media only screen and (max-width: 500px) {
    width: 100%;
    min-width: unset;
    margin-top: unset;
  }
`;

export const VoiceButton = styled.button`
  padding: 0.8rem 1rem;
  border-radius: 12px;
  border: ${props => (props.$selected ? '1px solid #61ade9' : '1px solid transparent')};
  outline: none;
  background: ${props => (props.$selected ? 'linear-gradient(180deg,  #1a88df 0%,  #1672ba 100%)' : '#f5f5f5')};
  color: ${props => (props.$selected ? '#fff' : '#1672ba')};
  cursor: pointer;
  font-size: 1.6rem;
  font-weight: 400;
  flex: 1;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.2rem;
  flex-wrap: wrap;
`;
